/** @jsxImportSource @emotion/react */

import { Trash2 } from 'lucide-react';
import { useLingui } from '@lingui/react/macro';
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import UDIconButton from 'ud-ui/components/icon-button';
import UDTippy from 'ud-ui/components/tippy';
import { selectActiveModal, selectIsEditingText } from 'modules/template-editor/store/editor/selectors';
import { useEditorManager, useEditorActiveObjects } from 'modules/template-editor/ui/context';

export function Delete() {
  const { t } = useLingui();
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useEditorManager();
  const activeObjects = useEditorActiveObjects();
  const isEditingText = useSelector(selectIsEditingText);

  const onClickDelete = useCallback(() => {
    if (!fabricManager) return;
    const activeObjects = fabricManager.canvas.getActiveObjects();
    fabricManager.canvas.discardActiveObject();
    fabricManager.canvas.remove(...activeObjects);
  }, [fabricManager]);

  useEffect(() => {
    const deleteOnDel = (event: KeyboardEvent) => {
      let isFocused = document.activeElement?.localName === 'input';
      if ((event.key === 'Delete' || event.key === 'Backspace') && !isEditingText && !isFocused) {
        onClickDelete();
      }
    };

    document.addEventListener('keydown', deleteOnDel);
    return () => {
      document.removeEventListener('keydown', deleteOnDel);
    };
  }, [isEditingText, onClickDelete]);

  return (
    <UDTippy disabled={Boolean(activeModal)} content={t`Удалить`} size="xs">
      <span style={{ display: 'inline-block' }}>
        <UDIconButton
          variant="ghost"
          icon={<Trash2 size={20} strokeWidth={1.5} />}
          onClick={onClickDelete}
          disabled={activeObjects.length === 0}
          tabIndex={0}
        />
      </span>
    </UDTippy>
  );
}
